import React from "react";
import { Link } from "react-router-dom";
import { ArrowLeft } from "lucide-react";

export default function Terms() {
  return (
    <div className="max-w-3xl mx-auto px-6 md:px-12 py-16 md:py-24" data-testid="terms-page">
      <Link to="/" className="btn-ghost text-xs inline-flex items-center gap-2 mb-8" data-testid="terms-back">
        <ArrowLeft size={14} /> Volver
      </Link>
      <div className="overline mb-3" style={{ color: "var(--brand-primary)" }}>Legal</div>
      <h1 className="font-serif text-4xl md:text-5xl font-light mb-6" style={{ color: "var(--text-primary)" }}>
        Términos y <em style={{ color: "var(--brand-primary)" }}>Condiciones</em>
      </h1>
      <p className="text-xs mb-10" style={{ color: "var(--text-muted)" }}>Última actualización: febrero 2026</p>

      <Section title="1. Naturaleza del servicio">
        PK2 Scarlett (en adelante, “la plataforma”, “nosotros”) es un <strong>directorio publicitario</strong> dirigido
        exclusivamente a personas adultas que muestran perfiles de acompañantes profesionales mayores de edad en México.
        La plataforma <strong>no organiza, contrata, intermedia ni cobra</strong> por servicios entre el visitante y la persona
        anunciada. Cualquier acuerdo entre ambas partes es un asunto privado entre adultos consintientes.
      </Section>

      <Section title="2. Solo para mayores de 18 años">
        Esta plataforma contiene <strong style={{ color: "var(--brand-primary)" }}>contenido para adultos (18+)</strong>.
        Al registrarte y/o continuar navegando confirmas, bajo protesta de decir verdad, que:
        <ul className="list-disc ml-6 mt-3 space-y-1">
          <li>Tienes <strong>18 años cumplidos o más</strong>.</li>
          <li>El acceso a contenido para adultos es legal en tu jurisdicción.</li>
          <li>Comprendes la naturaleza del contenido y lo consultas por voluntad propia.</li>
        </ul>
        Si eres menor de 18, abandona el sitio inmediatamente. Reportaremos cualquier intento de uso por menores a las
        autoridades competentes.
      </Section>

      <Section title="3. Registro y veracidad">
        Para anunciarse como Musa o Agencia, los usuarios deben completar el proceso de verificación: identificación oficial
        (INE) frente y reverso, selfie, selfie con INE en mano y un <strong>video grabado en vivo</strong>. La información
        falsa o el uso de identidades de terceros causa la <strong>baja inmediata</strong> y puede ser reportada a las
        autoridades.
      </Section>

      <Section title="4. Conducta prohibida">
        Queda terminantemente prohibido: <strong>cualquier mención, sugerencia o publicación de contenido relacionado con
        menores de edad</strong>; trata de personas; coerción; servicios sin consentimiento; venta de drogas; armas;
        material explícitamente ilegal; suplantación de identidad; spam; o cualquier delito previsto en las leyes mexicanas.
        El incumplimiento se reporta a la autoridad competente.
      </Section>

      <Section title="5. Pagos">
        Las suscripciones VIP, Boost 24h y otros productos se procesan a través de <strong>Mercado Pago</strong>. Los pagos
        son <strong>finales y no reembolsables</strong> excepto por error técnico verificable. Las comisiones del procesador
        se aplican según sus políticas vigentes.
      </Section>

      <Section title="6. Limitación de responsabilidad">
        PK2 Scarlett es un servicio publicitario. <strong>No garantizamos la disponibilidad, conducta, identidad ni el
        comportamiento</strong> de las personas anunciadas. El uso de la plataforma se realiza por cuenta y riesgo propios.
      </Section>

      <Section title="7. Modificaciones">
        Nos reservamos el derecho de modificar estos términos en cualquier momento, publicando la versión vigente en esta
        misma página. El uso continuado de la plataforma supone aceptación de los cambios.
      </Section>

      <Section title="8. Contacto">
        Para reportes, dudas o solicitudes legales: <a href="mailto:legal@pk2scarlett.com" style={{ color: "var(--brand-primary)" }}>legal@pk2scarlett.com</a>
      </Section>
    </div>
  );
}

function Section({ title, children }) {
  return (
    <section className="mb-8">
      <h2 className="font-serif text-2xl mb-3" style={{ color: "var(--text-primary)" }}>{title}</h2>
      <div className="text-sm" style={{ color: "var(--text-secondary)", lineHeight: 1.8 }}>{children}</div>
    </section>
  );
}
